var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackageUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.7778C11.2729 20.7778 10.5778 20.48 9.18844 19.8836C5.72978 18.3991 4 17.6578 4 16.4089V8.10845M12 20.7778C12.7271 20.7778 13.4222 20.48 14.8116 19.8836C18.2702 18.3991 20 17.6578 20 16.4089V8.10845M12 20.7778V12.04M4 8.10845C4 8.64533 4.71289 8.98489 6.13778 9.66222L8.73333 10.8978C10.3369 11.6596 11.1378 12.04 12 12.04M4 8.10845C4 7.57156 4.71289 7.23378 6.13778 6.55556M20 8.10845C20 8.64445 19.2871 8.984 17.8622 9.66222L15.2667 10.8978C13.6622 11.6587 12.8622 12.04 12 12.04M20 8.10845C20 7.57156 19.2871 7.23289 17.8622 6.55467M6.96178 13.0542L8.73422 13.8969M12 3V4.77778M15.5556 3.88889L14.2222 5.66667M8.44444 3.88889L9.77778 5.66667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageUser);
export default __webpack_public_path__ + "static/media/PackageUser.967c903dd68ff84c549eb508f8600efe.svg";
export { ForwardRef as ReactComponent };